module.exports = __webpack_public_path__ + "static/media/icon_huodon_qy.a57be329.png";